export const ConnectStores = require("./components/ConnectStores").default
export const connect = require("./connect").default
